import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';

import { ApplicationQuestion } from '@features/applicationQuestions';
import { useDeleteApplicationQuestion } from '@features/applicationQuestions/hooks/useDeleteApplicationQuestion';
import { Close, Delete } from '@mui/icons-material';
import { DeleteIcon } from '../../../../vectors/index';

type DeleteApplicationQuestionModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  applicationQuestion: ApplicationQuestion | null;
};

const DeleteApplicationQuestionModal: FC<
  DeleteApplicationQuestionModalProps
> = ({ isOpen, handleClose, applicationQuestion }) => {
  const [errorText, setErrorText] = useState('');

  const { deleteApplicationQuestion, isDeleteApplicationQuestionLoading } =
    useDeleteApplicationQuestion({
      setErrorText,
    });

  const handleDelete = () =>
    deleteApplicationQuestion(
      { question_id: applicationQuestion?.id! },
      {
        onSuccess: handleClose,
      },
    );

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={() => {
            handleClose();
          }}
        >
          <Close />
        </IconButton>
        <Box pt={3}>
          <DeleteIcon />
        </Box>
        <Typography variant="h4" sx={{ pt: 3 }}>
          Delete this question?
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack style={{ marginBottom: 10 }} spacing={3}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <LoadingButton
            variant="contained"
            color="error"
            startIcon={<Delete />}
            onClick={handleDelete}
            loading={isDeleteApplicationQuestionLoading}
          >
            Delete
          </LoadingButton>
          <Button
            startIcon={<Close />}
            disabled={isDeleteApplicationQuestionLoading}
            variant="outlined"
            color="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteApplicationQuestionModal;
